<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs11 sm5>
        <v-menu
          lazy
          :close-on-content-click="true"
          v-model="start_date"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            label="Start Date"
            v-model="date1_text_field"
            persistent-hint
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="date1" @input="start_date = false" no-title actions></v-date-picker>
        </v-menu>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs11 sm5>
        <v-menu
          lazy
          :close-on-content-click="true"
          v-model="end_date"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-right="40"
          max-width="290px"
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            label="End Date"
            v-model="date2_text_field"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker v-model="date2" @input="start_date = false" no-title actions></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      // date1: new Date().toISOString().substr(0, 10),
      // date2: new Date().toISOString().substr(0, 10),
      // date1: moment().format("YYYY-MM-DD"),
      date1: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),

      date2: moment().format("YYYY-MM-DD"),
      start_date: false,
      end_date: false
    };
  },
  created() {
    this.initiate();
  },
  mounted() {},

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    initiate() {
      this.$emit("update", "someValue");
    }
  },
  computed: {
    date1_text_field() {
      this.$emit("update", "someValue");
      return this.formatDate(this.date1);
    },
    date2_text_field() {
      this.$emit("update", "someValue");
      return this.formatDate(this.date2);
    }
  },
  watch: {}
};
</script>

<style>
</style>
